import { NodeEnum, type NodeDefault } from '../../types';
import { HandWritingExtractionNodeType } from './types';

const nodeDefault: NodeDefault<HandWritingExtractionNodeType> = {
  author: 'PIKA',
  about: '手写体抽取节点',
  icon: 'icon-video_fill_light',
  color: '#4CAF50',
  defaultData: {
    type: NodeEnum.HandWritingExtraction,
    tableConfig: '',
    name: '手写体抽取节点',
    title: '手写体抽取节点',
  },

  name: '手写体抽取节点',
  getAvailablePrevNodes() {
    return [];
  },
  getAvailableNextNodes() {
    return [];
  },
  checkValid() {
    return {
      isValid: true,
    };
  },
};

export default nodeDefault;
